// extracted by mini-css-extract-plugin
export default {"DraggableCard":"bfe_a"};